<template>
  <div>
    <v-card>
      <v-title>Field Options</v-title>
      <v-spacer></v-spacer>
      <v-card-text>
        <!-- <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field> -->
        <!-- <v-data-table
          :headers="headers"
          :items="rows"
          class="elevation-1"
          :pagination.sync="pagination"
          item-key="id"
          :loading="loading"
          :search="search"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{ props.item.componentName }}</td>
              <td>{{ props.item.ref }}</td>
              <td>
                {{ props.item.option }}
              </td>
              <td>{{ props.item.rule }}</td>
              <td class="justify-center layout px-0">
                <v-btn icon class="mx-0">
                  <v-icon color="teal" @click="showUpdateDialog(props.item)"
                    >edit</v-icon
                  >
                </v-btn>
                <v-btn icon class="mx-0">
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table> -->
        <ag-grid-vue
          style="width: 100%; padding: 5px"
          class="ag-theme-balham mb-4"
          domLayout="autoHeight"
          @grid-ready="onGridReady"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :frameworkComponents="frameworkComponents"
          :rowData="rows"
          pagination
          :paginationPageSize="10"
        ></ag-grid-vue>
        <v-card-actions class="pr-3 pb-3">
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="showUpdateDialog(false)"
            >Add new field</v-btn
          >
        </v-card-actions>
      </v-card-text>
    </v-card>
    <UpdateFieldDialog
      ref="updateDialogRef"
      :show="show"
      @hide="hideUpdateDialog"
      @save="save"
      @remove="remove"
    />
  </div>
</template>
<script>
import globalMixin from "@/mixins/globalMixin";
import { createNamespacedHelpers } from "vuex";
import { mapFieldOptionsFields } from "@/store/modules/fieldOptions";
import { FieldOption } from "@/models/FieldOption";
const { mapActions: mapFieldOptionsActions } =
  createNamespacedHelpers(`fieldOptions`);
import UpdateFieldDialog from "./fieldOptions/updateFieldOption";
import ActionBtn from "./fieldOptions/actionBtn";
import { AgGridVue } from "ag-grid-vue";

export default {
  mixins: [globalMixin],
  components: {
    UpdateFieldDialog,
    AgGridVue,
    ActionBtn,
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.frameworkComponents = {
      actionBtn: ActionBtn,
    };
    vm.defaultColDef = {
      autoHeight: true,
    };
    vm.columnDefs = [
      {
        headerName: "Component",
        sortable: true,
        field: "componentName",
        filter: true,
        minWidth: 200,
        maxWidth: 350,
      },

      {
        headerName: "Ref",
        sortable: false,
        field: "ref",
        filter: true,
        minWidth: 200,
        maxWidth: 350,
      },
      {
        headerName: "Options",
        sortable: true,
        field: "option",
        filter: true,
        suppressSizeToFit: true,
      },
      {
        headerName: "Rules",
        sortable: true,
        field: "rule",
        filter: true,
      },
      {
        headerName: "Actions",
        cellRenderer: "actionBtn",
        suppressSizeToFit: true,
        cellRendererParams: {
          clicked: function (param) {
            vm.showUpdateDialog(param);
          },
        },
      },
    ];
  },
  mounted() {
    const vm = this;
    vm.getFieldOptions();
  },
  data() {
    return {
      loading: false,
      search: "",
      show: false,
      gridOptions: null,
      columnDefs: null,
      defaultColDef: {
        resizable: false,
      },
      gridApi: null,
      frameworkComponents: null,
    };
  },
  computed: {
    ...mapFieldOptionsFields(["message", "rows"]),
  },
  methods: {
    ...mapFieldOptionsActions([
      "getFieldOptions",
      "updateFieldOptions",
      "removeFieldOptions",
    ]),
    onGridReady(params) {
      this.gridApi = params.api;
      this.getFieldOptions();

      this.gridApi.sizeColumnsToFit();
    },
    showUpdateDialog(item = null) {
      if (item) {
        let ref = this.$refs.updateDialogRef;
        ref.fieldOption = item;
      }
      this.show = true;
    },
    hideUpdateDialog() {
      this.$refs.updateDialogRef.fieldOption = new FieldOption();
      this.show = false;
    },
    save(data) {
      let vm = this;
      let payload = new FieldOption(data);
      vm.updateFieldOptions(payload).then((data) => {
        vm.hideUpdateDialog();
      });
    },
    remove(id) {
      let vm = this;
      vm.removeFieldOptions(id)
        .then((res) => {
          vm.hideUpdateDialog();
        })
        .catch((err) => vm.hideUpdateDialog());
    },
  },
};
</script>
